// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OLYPX4WHGjwsGvKFUevJ{font-size:20px;font-weight:bold}`, "",{"version":3,"sources":["webpack://./src/components/Round.scss"],"names":[],"mappings":"AAAA,sBACC,cAAA,CAEA,gBAAA","sourcesContent":[".round {\r\n\tfont-size: 20px;\r\n\t\r\n\tfont-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var round = `OLYPX4WHGjwsGvKFUevJ`;
export default ___CSS_LOADER_EXPORT___;
